import React, { useState, useEffect } from 'react';

import { isEmpty } from '../Util';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const BuyerSearchResult = ({ result, onClose }) => {
    const [selectedCompany, setSelectedCompany] = useState(null);

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', handleEscKey);
        document.documentElement.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        return () =>{ 
            document.removeEventListener('keydown', handleEscKey);
            document.body.style.overflow = 'auto'; 
            document.documentElement.style.backgroundColor = '';

        }
    }, [onClose]);

    const handleSelectCompany = (company) => {
        setSelectedCompany(company);
    }

    const handleConfirmCompany = () => {
        navigate("/Quotation", { state: { shouldPatchTransaction: true, buyer: selectedCompany} })
    };

    const { t } = useTranslation();
    const navigate = useNavigate();
    
    return (
        <div className="popin-overlay">
            
            <div className="popin-container p-2">
                <button className="close-button" onClick={onClose} >
                        &times;
                </button>
                <div className="popin-header mt-4 d-flex justify-content-center align-items-center">
                    
                    {!isEmpty(result) ?

                        <div className="az-pay-title p-4">
                            {t("BuyerSearchResult.title")}
                        </div>
                        :
                        <div className="az-pay-title p-4">
                        {t("BuyerSearchResult.noResult.title")}
                    </div>

                    }
                    
                    
                </div>
                
                {isEmpty(result) ?
                    <div className="p-4">
                        
                        <div className="middle-font az-pay-subtitle">
                            {t("BuyerSearchResult.noResult.text")}
                        </div>
                    </div>
                    :
                    <div className="p-4 popin-content">
                        <h3 className="mb-3 az-pay-subtitle">
                            {t("BuyerSearchResult.select.text")}
                        </h3>

                        <div className="company-list-container mt-3">
                            {result.map((company, index) => (
                                <div key={index}
                                    className={`border-2 p-3 mb-2 cursor-pointer company-card ${selectedCompany === company ? "selected" : ""}`}
                                    onClick={() => handleSelectCompany(company)}>
                                    
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="flex-fill">
                                            <div className="company-card-name">
                                                <span className='me-2'>
                                                    <img src={process.env.PUBLIC_URL + 'images/company-icon.svg'} alt="company"/>
                                                </span>
                                                {company.name}
                                            </div>
                                            <div>{company.address?.streetNumber} {company.address?.streetName}, {company.address?.postCode} {company.address?.city}</div>
                                            <div>{company.mainIdentifierTypeCode} - {company.mainIdentifierValue}</div>
                                        </div>
                                        
                                        <div className="company-radio-button ms-3">
                                            <img 
                                                src={selectedCompany === company 
                                                    ? process.env.PUBLIC_URL + 'images/radio-selected.svg'
                                                    : process.env.PUBLIC_URL + 'images/radio.svg'
                                                } 
                                                alt="radio"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className='d-flex company-search-container mt-4'>
                            <div data-testid="BuyerSearchResult.cancel.btn" className="flex-fill company-search-cancel-btn d-flex justify-content-center align-items-center" onClick={onClose}>
                                CANCEL
                            </div>
                            <div data-testid="BuyerSearchResult.select.btn" className={`flex-fill company-search-select-btn ${!selectedCompany ? "disabled" : ""}  d-flex justify-content-center align-items-center`} onClick={()=> selectedCompany && handleConfirmCompany()}>
                                SELECT
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default BuyerSearchResult;